<template>
    <div id="app" ref="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"/>
        </keep-alive>

        <router-view v-if="!$route.meta.keepAlive"/>
    </div>
</template>
<script>
    export default {
        created() {
            if (/Android|webOS| iPhone | iPad | iPod |BlackBerry|opera mini|opera mobile|appleWebkit.*mobile|mobile/i.test(navigator.userAgent)) {
                let url = window.location.protocol + "//" + window.location.host + '/#/index_mobile'; //我的移动端页面是在h5里面的所以这里添加了后面这一段'/h5/index.html'
                window.location.href = url; //如果有实际移动端域名网址的也可以忽略上面一段，直接输入移动端网址进行跳转就可以了

            } else {
                let url = window.location.protocol + "//" + window.location.host + '/#/index'; //我的移动端页面是在h5里面的所以这里添加了后面这一段'/h5/index.html'
                window.location.href = url; //如果有实际移动端域名网址的也可以忽略上面一段，直接输入移动端网址进行跳转就可以了

            }
        },
        mounted() {
            if (window.attachEvent) {
                alert("建议使用谷歌浏览器!")
            }
            this.getBrowserInterfaceSize();
        },
        methods:{
            getBrowserInterfaceSize() {
                var pageWidth = window.innerWidth;
                var pageHeight = window.innerHeight;
                if (typeof pageWidth != "number") { //在标准模式下面
                    if (document.compatMode == "CSS1Compat" ) {
                        pageWidth = document.documentElement.clientWidth;
                        pageHeight = document.documentElement.clientHeight;
                    } else {
                        pageWidth = document.body.clientWidth;
                        pageHeight = window.body.clientHeight;
                    }
                }
                this.$refs.app.style.height = pageHeight + 'px'
            }
        },
    }
</script>
<style lang="scss">

    /*清除默认设置*/
    * {
        margin: 0;
        padding: 0
    }

    li {
        list-style: none
    }

    img {
        vertical-align: top;
        border: none
    }

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        min-height: 8rem;
    }
    ::-webkit-scrollbar {
        width: 0;
    }
</style>
